import * as tslib_1 from "tslib";
import { Component } from 'react';
var View = /** @class */ (function (_super) {
    tslib_1.__extends(View, _super);
    function View() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Preact connection
        _this.redraw = function () { return _this.setState({}); };
        return _this;
    }
    Object.defineProperty(View.prototype, "dom", {
        get: function () {
            return this.base;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(View.prototype, "attrs", {
        get: function () {
            return this.props;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(View.prototype, "children", {
        get: function () {
            return this.props.children;
        },
        enumerable: true,
        configurable: true
    });
    // Public API
    View.prototype.onInit = function () { };
    View.prototype.onCreate = function (dom) { };
    View.prototype.onUpdate = function (dom) { };
    View.prototype.onRemove = function () { };
    View.prototype.onBeforeUpdate = function (nextAttrs, nextState) { };
    View.prototype.componentWillMount = function () {
        this.onInit();
    };
    View.prototype.componentDidMount = function () {
        this.onCreate(this.dom);
    };
    View.prototype.componentDidUpdate = function () {
        this.onUpdate(this.dom);
    };
    View.prototype.componentWillUnmount = function () {
        this.onRemove();
    };
    View.prototype.shouldComponentUpdate = function (nextAttrs, nextState, nextContext) {
        var res = this.onBeforeUpdate(nextAttrs, nextState);
        if (res === false)
            return false;
        return true;
    };
    return View;
}(Component));
export { View };
